<template>
  <section class="banner">
    <div class="banner__grid"></div>
    <div class="banner__beam banner__beam--one"></div>
    <div class="banner__beam banner__beam--two"></div>
    <div class="banner__inner">
      <p class="banner__eyebrow">{{ eyebrow }}</p>
      <h1>{{ title }}</h1>
      <p v-if="desc" class="banner__desc">{{ desc }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    eyebrow: {
      type: String,
      default: "Yufei Intelligent"
    },
    desc: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  min-height: 310px;
  overflow: hidden;
  display: flex;
  align-items: center;
  color: #fff;
  background:
    linear-gradient(120deg, rgba(5, 19, 48, 0.96), rgba(8, 55, 124, 0.86)),
    url("../assets/img/bgtop.jpg") center / cover no-repeat;
}

.banner::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 30%, rgba(22, 119, 255, 0.48), transparent 30%),
    radial-gradient(circle at 82% 18%, rgba(0, 216, 255, 0.28), transparent 26%);
}

.banner__grid {
  position: absolute;
  inset: 0;
  opacity: 0.22;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.18) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.18) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: linear-gradient(90deg, transparent, #000 18%, #000 82%, transparent);
}

.banner__beam {
  position: absolute;
  width: 360px;
  height: 360px;
  border-radius: 50%;
  filter: blur(22px);
  opacity: 0.45;
}

.banner__beam--one {
  right: 18%;
  top: -160px;
  background: rgba(22, 119, 255, 0.55);
}

.banner__beam--two {
  right: -80px;
  bottom: -180px;
  background: rgba(0, 212, 255, 0.35);
}

.banner__inner {
  position: relative;
  z-index: 1;
  width: min(1200px, calc(100% - 40px));
  margin: 0 auto;
  padding: 70px 0;
}

.banner__eyebrow {
  color: #8be8ff;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
}

h1 {
  margin-top: 14px;
  font-size: 46px;
  line-height: 1.18;
  font-weight: 900;
}

.banner__desc {
  max-width: 680px;
  margin-top: 16px;
  color: #d7e8ff;
  font-size: 17px;
  line-height: 1.8;
}

@media (max-width: 640px) {
  .banner {
    min-height: 250px;
  }

  .banner__inner {
    width: calc(100% - 24px);
    padding: 48px 0;
  }

  h1 {
    font-size: 32px;
  }
}
</style>
